import { endOfToday, isSameDay, getTime, endOfTomorrow } from 'date-fns'

export default {
    data() {
        return {}
    },
    created() {
        this.dialogRatingDateAutoClose()
    },
    computed: {},
    mounted() {},
    beforeDestroy() {},
    methods: {
        dialogRatingDateAutoClose() {
            let dateAutoClose = this.$store.state.dialog.rating.dateAutoClose
            let dateEndOfToday = getTime(endOfToday())

            if (dateAutoClose) {
                if (!isSameDay(dateEndOfToday, dateAutoClose)) {
                    //Наступил другой день значит закрываем форму

                    this.$store.commit('dialog/setShowAfterDialogChatSmiles', false)
                    this.$store.commit('dialog/setRatingShow', { view: '' })
                    this.$store.commit('dialog/setRatingDateAutoClose', { dateClose: null })
                }
            } else {
                this.$store.commit('dialog/setRatingDateAutoClose', { dateClose: dateEndOfToday })
            }
        }
    }
}
